import { render } from "./QuoteSection.vue?vue&type=template&id=04eaba69&ts=true"
import script from "./QuoteSection.vue?vue&type=script&lang=ts"
export * from "./QuoteSection.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__